import { InjectionToken, inject } from '@angular/core';
import { ConfigService } from './config.service';

export interface ApiConfig {
  apiUrl: string;
  environmentName: string;
  guestTokenEndpoint: string;
  systems: {
    name: string;
    url: string;
    permission: string;
  }[];
}

export const API_CONFIG = new InjectionToken<ApiConfig>('API_CONFIG', {
  providedIn: 'root',
  factory: () => {
    const configService = inject(ConfigService);
    return {
      apiUrl: configService.apiUrl,
      environmentName: configService.environmentName,
      guestTokenEndpoint: configService.guestTokenEndpoint,
      systems: configService.systems,
    };
  },
});
